import {createStrokeSVG} from './TEMPLATE'

// tabler: device-floppy
export const FloppyDisk_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2',
    'M10 14a2 2 0 1 0 4 0a2 2 0 1 0 -4 0',
    'M14 4l0 4l-6 0l0 -4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
